export const REFERENCE_SCREENS = {
  WELCOME_SCREEN: 0,
  QUESTION_ONE: 1,
  QUESTION_TWO: 2,
  QUESTION_THREE: 3,
  QUESTION_FOUR: 4,
  QUESTION_FIVE: 5,
  QUESTION_SIX: 6,
  CONFIRMATION: 7,
  POSTCONFIRMATION: 8,
};



// WEBPACK FOOTER //
// ./client/app/scenes/references/variables.js